<ion-button attr.id="{{ 'infozone_'+infozone.id }}" class="custom-thumb" *ngIf="!infozone.thumb" (click)="select()">
  <ion-icon name="information-circle"></ion-icon>
</ion-button>
<ion-button attr.id="{{ 'infozone_'+infozone.id }}" class="infozone-thumb custom-thumb" *ngIf="infozone.thumb" [ngStyle]="{'background-image': 'url(' + thumbpath + ')'}" (click)="select()">
  <div></div>
  <!--ion-icon name="information-circle"></ion-icon-->
</ion-button>